require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-voodoos-bs-jszip.json") })
        }
      }, "path---package-unpublished-voodoos-bs-jszip");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-voodoos-bs-jszip!./.cache/json/package-unpublished-voodoos-bs-jszip.json
// module id = 972
// module chunks = 231608221292675